import {
    Box,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    HStack,
    IconButton,
    useBreakpointValue,
    useColorModeValue,
    useDisclosure,
} from '@chakra-ui/react'
import React from 'react'
import {BiShoppingBag as ShoppingCartIcon} from 'react-icons/bi'

import useDraftShoppingCart from "./hooks/useDraftShoppingCart";
import {CartItem, CartItemDivider, CartPriceAndCheckout} from './ShoppingCartDetails'
import CheckoutModal from "./ShoppingCartDetails/CheckoutModal/CheckoutModal";

const stylingProps = (items) => (
    {
        content: `"${items}"`,
        position: "absolute",
        display: "block",
        top: "-0.25rem",
        right: "-0.25rem",
        width: '1rem',
        height: '1rem',
        fontSize: '0.75rem',
        borderRadius: '100px',
        backgroundColor: 'red',
        color: 'white',
        fontWeight: 'bold'
    }
)

function BottomBarContent() {
    return (
        <HStack w="100%" p={4} spacing={4}>
            <CartDrawer/>
            <CheckoutModal/>
        </HStack>
    )
}

function MobileBottomBar(props) {
    const MobileBottomBarBG = useColorModeValue('white', '#252525')
    const showBar = useBreakpointValue({base: "block", md: "none"})
    // const ref = React.useRef()
    // const [y, setY] = React.useState(0)
    // const { height = 0 } = ref.current?.getBoundingClientRect() ?? {}

    // const { scrollY } = useViewportScroll()
    // React.useEffect(() => {
    //   return scrollY.onChange(() => setY(scrollY.get()))
    // }, [scrollY])

    return (
        <Box
            // ref={ref}
            // shadow={y > height ? 'sm' : undefined}
            display={showBar}
            transition="box-shadow 0.2s"
            pos="fixed"
            bottom="0"
            zIndex="2"
            bg={MobileBottomBarBG}
            left="0"
            right="0"
            // borderTop="6px solid"
            // borderTopColor="orange"
            {...props}
        >
            <Flex height="4.5rem">
                <BottomBarContent/>
            </Flex>
        </Box>
    )
}

function CartDrawer() {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const btnRef = React.useRef()
    const {cartItemCount, isCartEmpty, draftShoppingCartItems} = useDraftShoppingCart()
    const HeaderBG = useColorModeValue('#E8ECED', '#2F2F2F')
    const ModalBG =  useColorModeValue('#F9FAFA', '#3D3D3D')

    return (
        <>
            <IconButton
                ref={btnRef}
                size='lg'
                onClick={onOpen}
                aria-label='View Cart'
                icon={<ShoppingCartIcon size='24px'/>}
                _after={!isCartEmpty ? stylingProps(cartItemCount) : null}
            />
            <Drawer
                isOpen={isOpen}
                placement='bottom'
                onClose={onClose}
                finalFocusRef={btnRef}
            >
                <DrawerOverlay/>
                <DrawerContent overflow='scroll' borderTopLeftRadius='8px' borderTopRightRadius='8px'>
                    <DrawerCloseButton/>
                    <DrawerHeader bg={HeaderBG} borderTopLeftRadius='8px' borderTopRightRadius='8px'>
                        Order Summary
                    </DrawerHeader>
                    <DrawerBody bg={ModalBG}>
                        {
                            draftShoppingCartItems.map((item) => (
                                <>
                                    <CartItem
                                        key={`${item.categoryItemName}-${item.categoryItemPrice}`}
                                            cartItem={item}
                                        />
                                        <CartItemDivider/>
                                    </>
                                ))
                        }
                        <CartPriceAndCheckout/>
                    </DrawerBody>

                    {/* <DrawerFooter>
                <Button                 
                    size="lg"        
                    isFullWidth
                    colorScheme="orange"
                    variant="solid"
                    //rightIcon={<BsFillCalendarFill />}
                >
                    Check Out
                </Button>              
            </DrawerFooter> */}
                </DrawerContent>
            </Drawer>
        </>
    )
}

export default MobileBottomBar
